module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/icon-exclamation-mark-425c77ec62ba241c50e6b5ff905c5c2a.svg";